export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDateBR(value: string | Date | null | undefined, fallback = '—'): string {
  if (!value) {
    return fallback;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return fallback;
  }
  return date.toLocaleDateString('pt-BR');
}

export function formatCurrency(
  amount: number | null | undefined,
  currency = 'BRL',
  fallback = '—'
): string {
  if (amount === null || amount === undefined) {
    return fallback;
  }
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(amount);
}
